(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('LenderIntegrationBlacklistDeleteController',LenderIntegrationBlacklistDeleteController);

    LenderIntegrationBlacklistDeleteController.$inject = ['$uibModalInstance', 'entity', 'LenderIntegrationBlacklist'];

    function LenderIntegrationBlacklistDeleteController($uibModalInstance, entity, LenderIntegrationBlacklist) {
        var vm = this;

        vm.lenderIntegrationBlacklist = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            LenderIntegrationBlacklist.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
